import React from 'react';

interface HamburgerMenuProps {
  isOpen: boolean;
  onClick: () => void;
}

export const HamburgerMenu: React.FC<HamburgerMenuProps> = ({ isOpen, onClick }) => {
  const lineStyle: React.CSSProperties = {
    height: '1.5px',
    backgroundColor: '#F5F5F5',
    borderRadius: '2px',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    transformOrigin: 'center',
  };

  return (
    <button
      onClick={onClick}
      style={{
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        padding: '12px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-end',
        width: '52px',
        height: '52px',
        position: 'relative',
        zIndex: 1000,
        transition: 'all 0.3s ease',
        gap: '6px'
      }}
      aria-label="Toggle menu"
    >
      {/* Top line */}
      <div
        style={{
          ...lineStyle,
          width: isOpen ? '24px' : '18px',
          transform: isOpen ? 'rotate(45deg) translate(5px, 5px)' : 'rotate(0deg)',
        }}
      />

      {/* Middle line */}
      <div
        style={{
          ...lineStyle,
          width: isOpen ? '24px' : '24px',
          opacity: isOpen ? 0 : 1,
          transform: isOpen ? 'scale(0)' : 'scale(1)',
        }}
      />

      {/* Bottom line */}
      <div
        style={{
          ...lineStyle,
          width: isOpen ? '24px' : '30px',
          transform: isOpen ? 'rotate(-45deg) translate(6px, -6px)' : 'rotate(0deg)',
        }}
      />
    </button>
  );
};
